// removed by extract-text-webpack-plugin
module.exports = {"Home":"_1T_7z","Wrapper":"_3kvLm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.scss
// module id = 683
// module chunks = 0